import { HttpContext, HttpContextToken } from "@angular/common/http";

/**
 * Opts a request out of the global error toast in `ErrorInterceptor`.
 *
 * The interceptor shows "Error: {detail}" for every failure it does not recognise, which is the
 * right default for a call whose failure has nowhere else to go. A surface that renders the
 * refusal itself (the LIS pages show every refusal as a sentence beside the action that caused it)
 * would otherwise say the same thing twice, once with an "Error:" in front of copy written to be
 * read on its own.
 */
export const SUPPRESS_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export function silentErrors(): HttpContext {
  return new HttpContext().set(SUPPRESS_ERROR_TOAST, true);
}
